import _taggedTemplateLiteral from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  query($order: [RefundsFindOrder!],$where: RefundsFindFilter) {\n    exportRefundsList(\n      order: $order,\n      where: $where\n    ) {\n      fileName\n      contentB64\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    mutation($approve: Boolean!, $orderIds: [Int!]!) {\n        auditRefund(approve: $approve, orderIds: $orderIds)\n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    query($order: [RefundsFindOrder!], $paging: PagingQuery, $where: RefundsFindFilter) {\n        findWeixinRefunds(\n            order: $order,\n            paging: $paging,\n            where: $where\n        ) {\n            refunds {\n                id\n                refundNumber\n                orderId\n                totalPrice\n                order {\n                    orderNumber\n                    timeEnd\n                    dealer {\n                        realname\n                        storePhone\n                    }\n                    address {\n                        realname\n                        phone\n                    }\n                phone\n                realname\n                }\n                auditStatus\n                createdAt\n            }\n            paging {\n                currentOffset\n                take\n                totalCount\n            }\n        }\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import gql from 'graphql-tag';
export var getWeixinRefund = gql(_templateObject());
export var handleRefundAudit = gql(_templateObject2());
export var exportWeixinRefundsList = gql(_templateObject3());